import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdSearch: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 19 19" fill="none" {...props}>
      <Path
        d="M0.8 7.41757C0.8 11.0507 3.66695 14.0351 7.1872 14.0351C10.7074 14.0351 13.5744 11.0507 13.5744 7.41757C13.5744 3.7844 10.7074 0.8 7.1872 0.8C3.66695 0.8 0.8 3.7844 0.8 7.41757ZM2.2312 7.41757C2.2312 4.5262 4.41713 2.26959 7.1872 2.26959C9.85672 2.26959 12.1432 4.52884 12.1432 7.41757C12.1432 10.3089 9.95728 12.5655 7.1872 12.5655C4.41713 12.5655 2.2312 10.3089 2.2312 7.41757Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.4"
      />
      <Path
        d="M11.5472 10.7462L11.4028 10.6077L11.2697 10.757L10.5694 11.5422L10.4363 11.6915L10.5806 11.8299L17.1666 18.1493L17.3109 18.2877L17.444 18.1385L18.1443 17.3533L18.2774 17.204L18.1331 17.0656L11.5472 10.7462Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.4"
      />
    </Svg>
  );
};

export default PdSearch;
